import React from 'react'
import { numberFormat } from 'core/utilities'
import {purchaseOrderDetailPath as poDetailPath,  } from 'routes'
import * as v from 'variables/styles'
const linkStyle = {
  color: v.ezMainColor,
  fontWeight: 'bold',
  textDecoration: 'underline',
  cursor: 'pointer',
}
export const dpItemColumns = [
  {
    Header: 'PO No.',
    accessor: 'poSapNumber',
    width: 100,
    resizable: false,
    Cell: row => <div style={linkStyle} onClick={() => window.open(poDetailPath(row.original.poId), '_blank')} >{row.value}</div>
  },
  {
    Header: ' Item No.',
    accessor: 'lineNo',
    className: 'center',
    width: 90,
  },
  {
    Header: 'Item Name',
    accessor: 'detail',
    className: 'left',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    width: 120,
    className: 'right',
    resizable: false,
    Cell: row => numberFormat(row.value, true),
  },
  {
    Header: 'Currency',
    accessor: 'currencyCode',
    width: 90,
    resizable: false,
    className: 'center itemCurrency',
  },
]